import { render } from "./ReplacementsEditor.vue?vue&type=template&id=fdd51c7e"
import script from "./ReplacementsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ReplacementsEditor.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/ReplacementsEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fdd51c7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fdd51c7e', __exports__)) {
    api.reload('fdd51c7e', __exports__)
  }
  
  module.hot.accept("./ReplacementsEditor.vue?vue&type=template&id=fdd51c7e", () => {
    api.rerender('fdd51c7e', render)
  })

}


export default __exports__